/** "luisa.heinzinger@finn.com" → "Luisa": whose person or job it is, on the team's pipeline (Oct 27 2026). */
export const ownerFirstName = (email: string | null | undefined) => {
  const part = `${email || ''}`.split('@')[0].split('.')[0];
  return part ? part[0].toUpperCase() + part.slice(1) : '';
};
